<ng-container *ngIf="PaymentResponse == null else receipt">


  <div class="wrapper">
    <div class="container px-0">
      <div *ngIf="!isExistingcard" class=" pb-2 fw-bold">
        <h5 class="title text-center mb-2 mt-2 fw-bold">  {{'paymentPage.paymentInformation' |translate}}</h5>
      </div>
      <div *ngIf="isExistingcard" class=" pb-2 fw-bold">
        <h5 class="title text-center mb-2 mt-2 fw-bold"> {{'checkinpayment.saveCardpayment_title'|translate}}</h5>
      </div>

      <div *ngIf="isExistingcard">
        <div class="form-row">
          <div class="col-md-4">
            <div class="form-group">
              <div class="border-bottom mb-2">
                <label class="fw-bold mb-2">
                  {{ 'checkinpayment.you_are_paying' | translate }} <span style="color: #5bc5d0;">${{amount}}</span>
                </label>
              </div>
            </div>
          </div>
          <div class=" col-md-4 mb-2">
            <label *ngIf="cardInfo.length>1" class="fw-bold mb-2"> {{'checkinpayment.choose_card'|translate}}</label>
            <label *ngIf="cardInfo.length==1" class="fw-bold mb-2"> {{'checkinpayment.select_card'|translate}}</label>
          </div>
        </div>

        <div class="container flex-grow-1 overflow-auto" style=" padding-right: 0px !important; padding-left: 0px !important;">
          <div class="specialist-list">
            <div class="">

            <div class="ltr-component" *ngFor="let card of cardInfo">
            <div class="card mb-4 pb-3">
              <div class="card-body p-0 mt-2">
                <div class="align-items-center d-flex justify-content-between">
                  <div>
                    <img width="32" class="mr-3" [src]="getCardImage(card.card_type)" />
                    <div class="card-details">
                      <label class="mb-0">{{card.card_type}} <strong>****{{card.token_number| slice:-4}}</strong></label>
                      <small class="text-danger d-block" *ngIf="isCardExpired(card.expiration_month, card.expiration_year)">{{'checkinpayment.card_expired'|translate}}</small>
                      <small class=" d-block" style="color: #53b0ba;" *ngIf="isCardExpiringSoon(card.expiration_month, card.expiration_year)">{{'checkinpayment.expiring_soon'|translate}}</small>
                    </div>
                  </div>

                  <div class="ctabtns">
                    <small *ngIf="isCardExpired(card.expiration_month, card.expiration_year)" class="text-dark d-block" (click)="deleteCardInfo(card)"> {{'link.delete'|translate}}</small>
                    <div *ngIf="!isCardExpired(card.expiration_month, card.expiration_year)" class="custom-control custom-radio">
                      <input class="custom-control-input" type="radio" name="creditcard" [id]="card.credit_card_id" (change)="selectCard(card)">
                      <label [for]="card.credit_card_id" class="custom-control-label mb-2"></label>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

            </div>
          </div>

        </div>
        <div class="col-md-12 mt-1 text-center">
          <button class="btn btn-primary btncare mt-5" type="button" (click)="addNewCard()">{{'button.add_new'|translate}}</button>
        </div>
        <div class="col-md-12 mt-1 text-center">
          <button class="btn btn-primary btncare mt-4" type="button" (click)="onSubmitPayment()">{{'button.make_payment'|translate}}</button>
        </div>

      </div>

      <div *ngIf="!isExistingcard">
        <form [formGroup]="paymentForm">
          <div class="form-row">
            <div class="col-md-4">
              <div class="form-group">
                <div class="border-bottom mb-2">
                  <label class="fw-bold mb-2">
                    {{ 'checkinpayment.you_are_paying' | translate }} <span style="color: #5bc5d0;">${{amount}}</span>
                  </label>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group ">
                <div class=" border-bottom mb-2">
                  <label class="fw-bold">{{'checkinpayment.nameon_card' |translate}}<span class="text-danger">*</span> </label>
                  <input formControlName="nameOnCard" maxlength="35" (input)="validatenameonCard($event, 'nameOnCard')"
                         type="text" class="form-control border-0 ltr-component" placeholder="{{'checkinpayment.nameon_card_placeholder' |translate}}">

                </div>
                <span *ngIf="getpaymentForm.nameOnCard.invalid && getpaymentForm.nameOnCard.touched" class="err">
                  <span *ngIf="getpaymentForm.nameOnCard.errors!.required" class="text-danger">{{'checkinpayment.nameon_card_error' |translate}}</span>
                </span>
              </div>
            </div>


            <div class="col-md-8 col-lg-4 ">
              <div class="form-group">
                <div class=" border-bottom mb-2">
                  <label class="fw-bold">{{'checkinpayment.CardNumber' |translate}}<span class="text-danger">*</span> </label>
                  <input type="text" inputmode="numeric" formControlName="ccn" [ngStyle]="{'border' : getpaymentForm.ccn.invalid
        && getpaymentForm.ccn.touched && getpaymentForm.ccn.errors!.required ? '1px solid red' : ''}" type="text" class="form-control border-0 ltr-component"
                         placeholder="{{'checkinpayment.CardNumber_placeholder' |translate}}" autocomplete="off" (keypress)="validateNumber($event, 19)" (input)="checkCCT($event)" autocomplete="off">

                  <span class="crimg">
                    <img *ngIf="creditCType != ''" src="{{creditCType}}" alt="">
                  </span>

                </div>
                <span *ngIf="getpaymentForm.ccn.invalid && getpaymentForm.ccn.touched" class="err">
                  <span *ngIf="getpaymentForm.ccn.errors!.required" class="text-danger">{{'checkinpayment.CardNumberRequired' |translate}}</span>
                  <span *ngIf="getpaymentForm.ccn.errors!.invalidNumber" class="text-danger">{{'checkinpayment.CardNumberInvalid' |translate}}</span>
                </span>
              </div>
            </div>

            <div class="col-md-12">
              <div class="form-group ">
                <div class="position-relative">
                  <label class="fw-bold">{{'paymentPage.expiryDate' |translate}}<span class="text-danger">*</span></label>
                  <div class="d-flex ">
                    <div class="col-md-6 col-6 " style="padding-left:0px !important">
                      <div class=" form-select border-bottom mb-2">
                        <select formControlName="dobMonth" class="form-control text-capitalize border-0" placeholder="Month">
                          <option value="" disabled selected>{{'verifypatient.month'|translate}}</option>
                          <option *ngFor="let month of months; let i = index" [value]="i+1">{{ month }}</option>
                        </select>
                      </div>
                      <span id="f-zip-err" class="err"
                            *ngIf="paymentForm.controls['dobMonth'].touched && paymentForm.controls['dobMonth'].invalid">
                        <span class="err"
                              *ngIf="paymentForm.controls['dobMonth'].errors && paymentForm.controls['dobMonth'].errors.required">
                          {{'verifypatient.month_error_msg'|translate}}.
                        </span>
                      </span>
                    </div>

                    <div class="col-md-6 col-6 " style="padding-left:0px !important">
                      <div class=" form-select border-bottom mb-2">
                        <select formControlName="dobyear" class="form-control text-capitalize border-0">
                          <option value="" disabled selected>{{'verifypatient.year'|translate}}</option>
                          <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                        </select>
                      </div>
                      <span id="f-zip-err" class="err"
                            *ngIf="paymentForm.controls['dobyear'].touched && paymentForm.controls['dobyear'].invalid">
                        <span class="err"
                              *ngIf="paymentForm.controls['dobyear'].errors && paymentForm.controls['dobyear'].errors.required">
                          {{'verifypatient.year_error_msg'|translate}}.
                        </span>
                      </span>
                    </div>

                  </div>
                </div>

              </div>

            </div>

            <div class="col-xs-6 col-sm-6 col-md-4" style="margin-top: -8px">

              <div class="form-group">

                <div class="border-bottom mb-2 mb-sm-auto">
                  <label class="fw-bold">
                    {{ 'paymentPage.cvv' | translate }}<span class="text-danger">*</span>
                  </label>

                  <!-- CVV Input Field -->
                  <input type="text" inputmode="numeric" formControlName="cvv" (input)="validateNumber($event, 4)" maxlength="4"
                         [ngStyle]="{'border' : getpaymentForm.cvv.invalid && getpaymentForm.cvv.touched && getpaymentForm.cvv.errors!.required ? '1px solid red' : ''}"
                         class="form-control border-0 ltr-component" placeholder="{{ 'paymentPage.cvv_placeholder' | translate }}" style="flex: 1;" />

                </div>

                <!-- Error Messages -->
                <span *ngIf="getpaymentForm.cvv.invalid && getpaymentForm.cvv.touched" class="err">
                  <span *ngIf="getpaymentForm.cvv.errors!.required" class="text-danger">{{ 'paymentPage.cvvrequired' | translate }}</span>
                  <span *ngIf="getpaymentForm.cvv.errors!.minlength" class="text-danger">{{ 'paymentPage.cvvInvalid' | translate }}</span>
                </span>
              </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-4" style="margin-top: 5px">
              <img width="100" [ngClass]="{'mr-3':!isRTL,'ml-5':isRTL}"
                   src="assets/images/security_code_img.png" alt="Security Code Help" style="margin-left:-70px" />
            </div>

            <ng-container *ngIf="currentLang === 'ur'; else otherLang">
              <div class="rtl-checkbox-local d-flex align-items-center gap-1"
                   [class.is-rtl]="currentLang === 'ur'">
                <!-- Info icon -->
                <span class="info-icon text-dark" (click)="showCardInfoPopup()">
                  <i class="fas fa-info-circle"></i>
                </span>
                <!-- Label + Checkbox -->
                <div class="custom-control custom-checkbox m-0">
                  <input type="checkbox"
                         class="custom-control-input"
                         id="idCheck" (change)="SaveCardOnFile($event)">
                  <label class="custom-control-label m-0" for="idCheck">
                    {{ 'checkinpayment.save_card_For_Future' | translate }}.
                  </label>
                </div>
              </div>
            </ng-container>
            <ng-template #otherLang>
              <div class="custom-control custom-checkbox">
                <input #agree class="custom-control-input" (change)="SaveCardOnFile($event)" type="checkbox" id="idCheck">
                <label class="custom-control-label" for="idCheck">{{'checkinpayment.save_card_For_Future'|translate}}. </label>
                <span class="ml-1 text-dark" (click)="showCardInfoPopup()"><i class="fas fa-info-circle"></i></span>
              </div>
            </ng-template>

            <!--<div class="custom-control custom-checkbox">
              <input #agree class="custom-control-input" (change)="SaveCardOnFile($event)" type="checkbox" id="idCheck">
              <label class="custom-control-label" for="idCheck">{{'checkinpayment.save_card_For_Future'|translate}}. </label>
              <span class="ml-1 text-dark" (click)="showCardInfoPopup()"><i class="fas fa-info-circle"></i></span>
            </div>-->

            <div class="col-md-12 mt-1 text-center">
              <button class="btn btn-primary btncare mt-2" type="button" (click)="onSubmitPayment()">{{'button.make_payment'|translate}}</button>
            </div>

          </div>
        </form>
      </div>


    </div>
  </div>



  <footer class="p-3">
    <div class="container p-0">
      <div class="d-flex justify-content-between align-items-center">
        <a class="btn btn-outline-primary" type="button" href="javascript:void(0)" (click)="onClickBack()">{{'button.back'|translate}}</a>

        <a class="btn btn-primary" type="button" (click)="onFinishIntake()">{{'button.finish'|translate}}</a>
      </div>
    </div>
  </footer>

</ng-container>

<ng-template #receipt>

  <div class="wrapper">
    <div class="container px-0">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="card border">
            <div class="card-body">
              <h5 class="bg-info mb-3 p-3 text-center text-white">{{'paymentPage.paymentReceipt'|translate}}</h5>
              <div class="mt-5">
                <div class="text-dark">{{'checkinpayment.patient_name'|translate}}: {{(PaymentResponse.nameonCard | titlecase)}}  </div>
                <div class="mt-2">{{'checkinpayment.date'|translate}}: {{currentDate | date:'MMMM dd, yyyy'}}</div>
                <div class="mt-2">{{'checkinpayment.reference_no'|translate}}: {{PaymentResponse.transactionID || 'N/A'}}</div>
              </div>

              <div class="mt-5">
                <div class="d-flex justify-content-between mt-3">
                  <strong>{{'checkinpayment.outbalance'|translate}} </strong>
                  <strong><span [ngStyle]="{'color': isMinuDueAmount != 'false' ? 'red':''}"><span *ngIf="isMinuDueAmount != 'false'">(</span>${{isMinuDueAmount != 'false' ? isMinuDueAmount : paymentDetials.data.amT_DUE | number : '.2-2'}}<span *ngIf="isMinuDueAmount != 'false'">)</span></span></strong>
                </div>
                <div class="d-flex justify-content-between mt-3">
                  <strong>{{'checkinpayment.copay'|translate}} </strong>
                  <strong>${{paymentDetials.data.currentDayAmount! | number : '.2-2'}}</strong>

                </div>
                <div class="d-flex justify-content-between mt-3 text-dark">
                  <strong>{{'checkinpayment.total'|translate}}</strong>
                  <strong><span [ngStyle]="{'color': isMinuTotalAmount != 'false' ? 'red':''}"><span *ngIf="isMinuTotalAmount != 'false'">(</span>${{isMinuTotalAmount != 'false' ? isMinuTotalAmount  : paymentDetials.data.totalAmount | number : '.2-2'}}<span *ngIf="isMinuTotalAmount != 'false'">)</span></span></strong>
                </div>
              </div>
              <div class="devider"> </div>
              <div>
                <strong>{{'checkinpayment.payment'|translate}}:</strong><br>
                <div class="d-flex justify-content-between mt-3">
                  <strong>{{(ObjPayment.cradittype | titlecase) || 'N/A'}} ****{{PaymentResponse.ccn || 'N/A'}}</strong>
                  <strong>${{PaymentResponse.amount || 'N/A'}}</strong>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <footer class="p-3">
    <div class="container p-0">
      <div class="d-flex justify-content-center align-items-center">
        <a class="btn btn-primary btnfinish" type="button" href="javascript:void(0)" (click)="finishClicked()">{{'button.finish'|translate}}</a>
      </div>
    </div>
  </footer>
</ng-template>

<!-- email sent dialog -->
<div data-backdrop="static" [ngStyle]="{'display' : emailSent ? 'block' : 'none'}" data-keyboard="false" class="modal modal-md collapse" id="emailsuccess"> 
<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content"> 
      <div class="modal-body  p-4 text-center">
        
          <h5 class="font-weight-bolder mb-3 text-primary"><strong>{{'paymentPage.emailSentSuccess'|translate}}</strong></h5>
          <button type="button" id="closeDeleteFamilyHistory" (click)="finishClicked()" class="btn btn-primary" data-dismiss="modal">{{'button.ok'|translate}}</button> 
      </div> 
  </div>
</div>
</div>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="leavePayment-modal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="mb-4">
          {{'checkinpayment.are_you_sure_to_fisnish'|translate}}
        </h5>

        <button type="button" class="btn btn-outline-primary mr-3" data-dismiss="modal"
                (click)="onFinish()">
          {{'button.finish'|translate}}
        </button>
        <button type="button" data-toggle="modal" data-dismiss="modal" class="btn btn-primary "
                (click)="onSubmitPayment()">
          {{'button.make_payment'|translate}}
        </button>

      </div>
    </div>
  </div>
</div>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="cardinfo-modal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3"><strong> {{('checkinpayment.save_card_For_Future'|translate)|titlecase}} </strong></h5>
    
        <h5 class="mb-4">
          {{'checkinpayment.info_text'|translate}}
        </h5>
        <button type="button" class="btn btn-primary" data-dismiss="modal">
          {{'button.ok'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="delete-creditcard">

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body  p-4 text-center">
        <h5 class="mb-3">{{'checkinpayment.deleteCreditCard'|translate}} <strong>****{{cardToken| slice:-4}}</strong>?</h5>
        <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal"
                id="closeDeletecardModel">
          {{'button.cancel'|translate}}
        </button>
        <button type="button" id="closeDeletecard" (click)="onConfirmDeleteCreditCard()"
                class="btn btn-primary ">
          {{'button.delete'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>
